const Book = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-book"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-book"
      viewBox="0 0 68 55"
      width={_width}
      fill="none"
      {...props}
    >
      <path
        d="M62.3332 41.8502V11.6752C62.3332 8.67523 59.5565 6.45023 56.1848 6.70023H56.0148C50.0648 7.15023 41.0265 9.82523 35.9832 12.6252L35.5015 12.9002C34.6798 13.3502 33.3198 13.3502 32.4982 12.9002L31.7898 12.5252C26.7465 9.75023 17.7365 7.10023 11.7865 6.67523C8.41484 6.42523 5.6665 8.67523 5.6665 11.6502V41.8502C5.6665 44.2502 7.8765 46.5002 10.5965 46.8002L11.4182 46.9002C17.5665 47.6252 27.0582 50.3752 32.4982 53.0002L32.6115 53.0502C33.3765 53.4252 34.5948 53.4252 35.3315 53.0502C40.7715 50.4002 50.2915 47.6252 56.4682 46.9002L57.4032 46.8002C60.1232 46.5002 62.3332 44.2502 62.3332 41.8502Z"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M34 13.7251V51.2251"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.9585 21.2251H15.5835"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.0835 28.7251H15.5835"
        stroke="#292D32"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Book;
